export const getItemFromArray = ({ array, id }) => {
    return array.find((item) => item.id === id);
};
